import { useState, useEffect } from 'react';
import { fetchCountryCode, fetchTaxSystem, getAdapter, getCachedCountryCode, getCachedTaxSystem, DEFAULT_COUNTRY } from './index';

// Loads the current account owner's fiscal country and exposes the matching
// adapter. Mirrors useFeatures() — country flags gate country-specific fiscal
// behaviour (tax math, identifiers, e-invoice), the same way feature flags gate
// whole modules.
//
//   const { adapter, countryCode, loading } = useFiscalAdapter();
//   const totals = adapter.computeTotals(lines, opts);
//
// Never returns null: falls back to the default-country adapter while loading
// or on error, so consumers can render without guarding.
//
// SEEDING: the initial country comes from the country this browser last
// resolved (localStorage, written by fetchCountryCode) instead of the ES
// default. Without it EVERY page mounted with Spain's adapter for the duration
// of the profile round-trip, which on a Pakistani account meant euro symbols in
// Gastos/Artículos and — worse — brand-new document lines being created with
// the Spanish 21% IVA default before the real 18% GST arrived. Falls back to
// DEFAULT_COUNTRY on a browser that has never resolved a country.
//
// Spain also carries the owner's tax system (IVA / IGIC / IPSI, lib/taxSystem)
// the same way: seeded from the last resolved value, refreshed with the profile.
export function useFiscalAdapter() {
  const [countryCode, setCountryCode] = useState(() => getCachedCountryCode() || DEFAULT_COUNTRY);
  const [taxSystem, setTaxSystem] = useState(() => getCachedTaxSystem());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchCountryCode()
      .then(async (code) => {
        const sys = await fetchTaxSystem().catch(() => null);
        if (active) { setCountryCode(code); if (sys) setTaxSystem(sys); setLoading(false); }
      })
      .catch(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { adapter: getAdapter(countryCode, taxSystem), countryCode, taxSystem, loading };
}
